import './App.css';
import Header from './components/1.Header/Header';
import Hero from "./components/2.Hero/Hero";
import KnowUs from "./components/3.KnowUs/KnowUs";
import Services from "./components/4.Services/Services";
import Clients from './components/6.Clients/Clients';
// import Testimonials from "./components/7.Testimonials/Testimonials";
import Contact from "./components/8.Contact/Contact";
import Footer from "./components/9.Footer/Footer"
import {Helmet} from 'react-helmet-async'

function App() {
  return (
    <>
      <Helmet>
        <title>CFR Estudio</title>
        <meta
          name="description"
          content="Estudio del arquitecto Celso Rodriguez"
        />
        <link rel="canonical" href="https://cfrestudio.com/" />
      </Helmet>
      <div className="App">
        <Header />
        <Hero />
        <Services />
        <Clients />
        {/* <Testimonials /> */}
        <KnowUs />
        <Contact />
        <Footer />
      </div>
    </>
  );
}

export default App;
